import React from "react";

const Other = ({ size = 50, color }: any) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      fill={color}
    >
      <path d="M0.5 3.66973C0.5 1.64299 2.12069 0 4.11991 0H33.0792C35.0784 0 36.6991 1.64299 36.6991 3.66972V33.0275C36.6991 35.0543 35.0784 36.6972 33.0792 36.6972H4.11991C2.12069 36.6972 0.5 35.0543 0.5 33.0275V3.66973Z" />
      <path d="M44.3009 3.66973C44.3009 1.64299 45.9216 0 47.9208 0H76.8801C78.8793 0 80.5 1.64299 80.5 3.66972V33.0275C80.5 35.0543 78.8793 36.6972 76.8801 36.6972H47.9208C45.9216 36.6972 44.3009 35.0543 44.3009 33.0275V3.66973Z" />
      <path d="M0.5 46.9725C0.5 44.9457 2.12069 43.3028 4.11991 43.3028H33.0792C35.0784 43.3028 36.6991 44.9457 36.6991 46.9725V76.3303C36.6991 78.357 35.0784 80 33.0792 80H4.11991C2.12069 80 0.5 78.357 0.5 76.3303V46.9725Z" />
      <path d="M59.5045 46.055C59.5045 44.535 60.72 43.3028 62.2195 43.3028C63.7189 43.3028 64.9344 44.535 64.9344 46.055V77.2477C64.9344 78.7678 63.7189 80 62.2195 80C60.72 80 59.5045 78.7678 59.5045 77.2477V46.055Z" />
      <path d="M44.3009 61.4679C44.3009 59.9478 45.5164 58.7156 47.0158 58.7156H77.7851C79.2845 58.7156 80.5 59.9478 80.5 61.4679C80.5 62.9879 79.2845 64.2202 77.7851 64.2202H47.0158C45.5164 64.2202 44.3009 62.9879 44.3009 61.4679Z" />
    </svg>
  );
};

export default Other;
